/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Alternativecontactperson2Inputs */

const de__field_alternativecontactperson2 = /** @type {(inputs: _Field_Alternativecontactperson2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternative Kontaktperson`)
};

/**

* @param {_Field_Alternativecontactperson2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_alternativecontactperson2 = /** @type {((inputs?: _Field_Alternativecontactperson2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Alternativecontactperson2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_alternativecontactperson2(inputs)
});
export { _field_alternativecontactperson2 as "_field_alternativeContactPerson" }